// O que o REPRESENTANTE le. O texto cru do servidor fica na tela, dobrado
// atras de "detalhes tecnicos" -- ali e para ela diagnosticar, aqui e para
// quem esta vendendo entender o que aconteceu.

const PADRAO = 'Não foi aceito pelo servidor. Avise o suporte.'
const PEDE_SUPORTE_SCHEMA = 'O servidor não reconheceu este dado. Avise o suporte.'

const POR_CODIGO: Record<string, string> = {
  '23505': 'Esse cadastro já existe.',
  '23502': 'Faltou preencher um campo obrigatório.',
  '23503': 'Depende de um cadastro que não existe mais.',
  '23514': 'O servidor não aceitou este valor.',
  '42501': 'O servidor não aceitou esta gravação. Avise o suporte.',
  '42703': PEDE_SUPORTE_SCHEMA,
  '42P01': PEDE_SUPORTE_SCHEMA,
  PGRST204: PEDE_SUPORTE_SCHEMA,
}

export function mensagemHumana(erro: { code?: string } | null | undefined): string {
  return POR_CODIGO[erro?.code ?? ''] ?? PADRAO
}
